import { isValidNumber } from 'libphonenumber-js'

const COUNTRY_CODE = 'RU'

export default number => isValidNumber(number, COUNTRY_CODE)
